import { render, staticRenderFns } from "./TestKitInfoResult.vue?vue&type=template&id=26631a8b&scoped=true&"
import script from "./TestKitInfoResult.vue?vue&type=script&lang=js&"
export * from "./TestKitInfoResult.vue?vue&type=script&lang=js&"
import style0 from "./TestKitInfoResult.vue?vue&type=style&index=0&id=26631a8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26631a8b",
  null
  
)

export default component.exports